import {
  DialogSwal,
  NonDialogSwal,
} from './Functions/MatchMessageBoxMode';

const SwalAlert = (
  Type,
  Message,
  IsDialog,
  DialogFunction,
  bodyMessage,
  stateLift,
  autoClose,
  noTitle
) => {
  if (IsDialog) {
    return DialogSwal(
      Message,
      Type,
      DialogFunction,
      bodyMessage,
      stateLift,
      autoClose,
      noTitle
    );
  } else {
    return NonDialogSwal(Message, Type, autoClose, noTitle);
  }
};

export default SwalAlert;
